import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const redirectPath = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? '/mindex' : '/index'
    // const redirectPath = "/index"
const upgradingRoute = {
        path: '/upgrading',
        name: 'ServiceUpgrading',
        component: () =>
            import ('@/views/ServiceUpgrading.vue')
    }

const normalRoutes = [{
        path: '/',
        redirect: redirectPath,
    },
    upgradingRoute,
    {
        path: '/index',
        name: 'PCIndex',
        meta: { type: 'pc' },
        component: () =>
            import ('@/views/PC_update/Index.vue')
    },
    {
        path: '/product',
        name: 'PCProduct',
        meta: { type: 'pc' },
        component: () =>
            import ('@/views/PC_update/Product.vue'),
        redirect: "/product/list/rangcha",
        children: [{
                path: '/product/list/rangcha',
                name: 'PCRangchaList',
                meta: { type: 'pc' },
                component: () =>
                    import ('@/views/PC_update/RangchaList.vue'),
            },
            {
                path: '/product/list/tasantea',
                name: 'PCTasnateaList',
                meta: { type: 'pc' },
                component: () =>
                    import ('@/views/PC_update/TasnateaList.vue'),
            }, {
                path: '/product/rangcha/detail',
                name: 'PCRangchaProductDetail',
                meta: { type: 'pc' },
                component: () =>
                    import ('@/views/PC_update/RangchaProductDetail.vue'),
            },
            {
                path: '/product/tasantea/detail',
                name: 'PCTasanteaProductDetail',
                meta: { type: 'pc' },
                component: () =>
                    import ('@/views/PC_update/TasanteaProductDetail.vue'),
            },

        ]
    },
    {
        path: '/company',
        name: 'PCCompany',
        meta: { type: 'pc' },
        component: () =>
            import ('@/views/PC_update/Company.vue')
    },
    {
        path: '/news',
        name: 'PCNews',
        meta: { type: 'pc' },
        component: () =>
            import ('@/views/PC_update/News.vue')
    },
    {
        path: '/pc/test',
        name: 'Test',
        meta: { type: 'pc' },
        component: () =>
            import ('@/views/PC_update/Test.vue'),
    },
    {
        path: '/mindex',
        name: 'MobileIndex',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile_update/Index.vue')
    },
    {
        path: '/mrangcha/list',
        name: 'MobileRangchaProductList',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile_update/RangchaProductList.vue')
    },
    {
        path: '/mrangcha/detail',
        name: 'MobileRangchaProductDetail',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile_update/RangchaProductDetail.vue')
    },
    {
        path: '/mtasantea/list',
        name: 'MobileTasanteaProductList',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile_update/TasanteaProductList.vue')
    },
    {
        path: '/mtasantea/detail',
        name: 'MobileTasanteaProductDetail',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile_update/TasanteaProductDetail.vue')
    },
    {
        path: '/mcompany',
        name: 'MobileCompanyIntroduce',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile_update/CompanyIntroduce.vue')
    },
    {
        path: '/mnews',
        name: 'MobileCompanyNews',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile_update/CompanyNews.vue')
    },
    {
        path: '/mtest',
        name: 'MobileTest',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile_update/MTest.vue')
    },

]

const routes = normalRoutes

const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

router.beforeEach((to, from, next) => {
        if (to.meta.type == "mobile" && redirectPath == "/index") return next("/index")
        if (to.meta.type == "pc" && redirectPath == "/mindex") return next("/mindex")
        return next()
    })
    // 解决重复点击路由报错的BUG
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}


export default router
